module.exports = __webpack_public_path__ + "static/img/Frame 1848.67a9e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1848.png
// module id = B9ow
// module chunks = 12